import React from 'react';
import { CardAccountInfoProps } from './types';
import {
    Avatar,
    AvatarContainer,
    AvatarWrapper,
    Content,
    Controls,
    Name,
    Role,
    Wrapper,
} from './card-account-info.styles';
import { Typography } from '@shared/ui/typography/typography';
import { Photo } from '@shared/ui/photo/photo';
import { ROUTE_ADMIN_PROFILE } from '@shared/config/routes/routes';
import { Button } from '@vtbhome/juicyfront';
import { AllEdit } from '@vtbhome/juicyfront/indexIcon';
import { usePrefetchCurrentUser } from '@entities/current-user/api/credentials-user-api';
import { useRedirect } from '@shared/lib/hooks/use-redirect/use-redirect';

export const CardAccountInfo: React.FC<CardAccountInfoProps> = ({
    name,
    role,
    department,
    avatarUrl,
    children,
    showEditButton = false,
}) => {
    const redirect = useRedirect();
    const prefetchCurrentUser = usePrefetchCurrentUser('currentUser', { ifOlderThan: 60 });

    const handleHoverEdit = () => {
        prefetchCurrentUser();
    };

    const handleEditProfile = () => {
        redirect({ url: `${ROUTE_ADMIN_PROFILE}` });
    };

    return (
        <Wrapper>
            <AvatarWrapper>
                <Avatar>
                    <AvatarContainer>
                        <Photo photoUrl={avatarUrl} name={name} />
                        {children}
                    </AvatarContainer>
                </Avatar>
            </AvatarWrapper>
            <Content>
                <Name size='h6'>{name}</Name>
                <Role size='body1_long'>{role}</Role>
                <Typography size='body1_long' color='neutral_50'>
                    {department}
                </Typography>
            </Content>
            {showEditButton && (
                <Controls>
                    <Button
                        buttonType='secondary'
                        size='m'
                        startAdornment={<AllEdit size='xs' />}
                        onMouseEnter={handleHoverEdit}
                        onClick={handleEditProfile}>
                        Редактировать
                    </Button>
                </Controls>
            )}
        </Wrapper>
    );
};
